import ForeignWindowImpl from './foreignwindow.jsx';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * ForeignWindow module provides the possibility to view foreign content given an url.
 * The module will act upon intents of type SHOW_FOREIGN_WINDOW.
 * The window is closed either by the application dispatching the HIDE_FOREIGN_WINDOW intent action,
 * or the user clicking outside the visible window area.
 *
 * @example <caption>Example SHOW_FOREIGN_WINDOW intent that will open in a foreign window</caption>
 * dispatch(intentActions.publishIntent({
 *   type: IntentType.SHOW_FOREIGN_WINDOW,
 *   data: {
 *     url: 'http://www.mff.se',
 *     type: 'validate-session'
 *   }
 * }))
 *
 * @class ForeignWindow
 * @name module
 * @memberof Mojito.Modules.ForeignWindow
 */

/**
 * ForeignWindow prop types.
 *
 * @property {object} content - Object containing url and type.
 * @property {string} content.url - URL of website to show.
 * @property {string} [content.type] - Type of page which will be dispatched when outside click happens.
 *
 * @memberof Mojito.Modules.ForeignWindow
 */

const propTypes = {
    content: PropTypes.object.isRequired,
};

export default UIControllerView('ForeignWindow', ForeignWindowImpl, propTypes);
